/**
 * Per-product packaging accent — a COSMETIC tint only (not backend data). Keyed by the product's
 * slug; falls back to the product's category accent, then brand green. Sourced from the packaging
 * artwork, matching the reference design's accent map. Add a line when a new product needs a
 * distinct tint; otherwise it inherits its category's accent.
 */
const PRODUCT_ACCENT: Record<string, string> = {
  agn: '#1E93AE',
  'agn-lte': '#2C6D4E',
  aminopf: '#9B33B7',
  biodynamic: '#9A6B34',
  biovin: '#137E3E',
  'c4l-biofoliar': '#D0951F',
  'fulvic-25': '#8A2D54',
  'natures-green-4-plus': '#3FA82A',
  "nature-s-green-4-plus": '#3FA82A',
  'plant-armor-elite': '#D5A635',
  hydretain: '#1F86C9',
};

const BRAND_GREEN = '#159A3C';

export function productAccent(slug: string, categoryAccent?: string | null): string {
  return PRODUCT_ACCENT[slug] ?? categoryAccent ?? BRAND_GREEN;
}
